import { clearLoginDetails } from "../auth";
import { clearAllPolicyCountDetails } from "../dashboard";
import { clearAllMonthlyPolicyReport } from "../policyList";

export const CLEAR_REDUX_STATE = {
  CLEAR_LOGIN_DETAILS: clearLoginDetails,
  CLEAR_ALL_POLICY_COUNT_DETAILS: clearAllPolicyCountDetails,
  CLEAR_ALL_MONTH_POLICY_REPORT: clearAllMonthlyPolicyReport,
};
